import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { FeatureFlags } from '@api-types/types/feature-flags';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsHttpClient {
  private readonly baseUrl = environment.api.url;
  private readonly httpClient = inject(HttpClient);

  getFeatureFlags(): Observable<FeatureFlags> {
    return this.httpClient.get<FeatureFlags>(`${this.baseUrl}/feature-flags`);
  }
}
